<div class="user-rating-container">
  <ng-container *ngFor="let r of ratings">

    <img *ngIf="r == 0" src="./assets/images/star_orange_empty.png" alt="star" [class.big]="bigImg == true">
    <img *ngIf="r == 1" src="./assets/images/star_orange_full.png" alt="star" [class.big]="bigImg == true">
    <img *ngIf="r == 2" src="./assets/images/star_orange_half.png" alt="star" [class.big]="bigImg == true">

  </ng-container>
  <span class="rating">{{rating}}</span> <span class="rating" *ngIf="count">, {{count}} {{getString('ratings')}}</span>
</div>
